
<search-dropdown 
  [items]="purposes" 
  [label]="'purpose'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="onChanged($event)"
  [(ngModel)]="purposeId">
</search-dropdown>